(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-featured-product-tabs"] && !Shopify.designMode) return;
  try {
    
	class LTAFeaturedProductTabs extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			setTimeout(() => this._setup(), 0)
		}

		_setup() {
			this.tabsCarousel = this.querySelector('.l-sFPTabs__tabs')
			this.tabButtons = this.querySelectorAll('.l-sFPTabs__tabs-item')
			this.panels = this.querySelectorAll('.l-sFPTabs__swiper-wrapper')

			if (!this.tabButtons.length || !this.panels.length) return

			this.tabButtons.forEach((btn, index) => {
				btn.addEventListener('click', (e) => this._onTabClick(e, index))
			})

			this._setActiveTab(0)
			this._bindSwiperSync()
		}

		_bindSwiperSync() {
			if (this._swiperSyncBound) return
			if (!this.tabsCarousel?.swiperCarousel) {
				document.addEventListener('l:vendor:loaded', () => this._bindSwiperSync(), { once: true })
				return
			}
			this._swiperSyncBound = true
			this.tabsCarousel.swiperCarousel.on('slideChange', () => {
				const index = this.tabsCarousel.swiperCarousel.activeIndex
				this._showPanel(index)
				this._setActiveTab(index)
			})
		}

		_onTabClick(event, index) {
			event.preventDefault()
			this._showPanel(index)

			// Slide tabs carousel to center the clicked tab
			if (this.tabsCarousel?.swiperCarousel) {
				this.tabsCarousel.slideTo(index)
			}
			this._setActiveTab(index)
		}

		_showPanel(index) {
			this.panels.forEach((panel, i) => {
				panel.classList.toggle('l-hidden', i !== index)
			})
		}

		_setActiveTab(index) {
			this.tabButtons.forEach((btn, i) => {
				btn.classList.toggle('is-active', i === index)
			})
		}
	}

	customElements.define('l-featured-product-tabs', LTAFeaturedProductTabs)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-select-your-university"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-select-your-university')) {
		class LTASelectYourUniversity extends HTMLElement {
			constructor() {
				super()
				this.onSelectChange = this.onSelectChange.bind(this)
			}

			connectedCallback() {
				this.selectEl = this.querySelector('select')

				if (!this.selectEl) return

				this.selectEl.addEventListener('change', this.onSelectChange)
			}

			disconnectedCallback() {
				this.selectEl && this.selectEl.removeEventListener('change', this.onSelectChange)
			}

			onSelectChange(event) {
				const selectedUrl = event.target?.value?.trim()

				if (!selectedUrl) return

				window.location.assign(selectedUrl)
			}
		}

		customElements.define('l-select-your-university', LTASelectYourUniversity)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-size-chart"] && !Shopify.designMode) return;
  try {
    
	class ASizeChart extends HTMLElement {
		connectedCallback() {
			this.tabs = Array.from(this.querySelectorAll('[data-size-chart-tab]'))
			this.panels = Array.from(this.querySelectorAll('[data-size-chart-panel]'))

			this.tabs.forEach((tab) => tab.addEventListener('click', this._onTabClick.bind(this)))
		}

		_onTabClick(event) {
			const button = event.currentTarget
			const targetId = button.getAttribute('data-target')
			if (!targetId) return

			this.tabs.forEach((tab) => {
				const isActive = tab === button
				tab.setAttribute('aria-selected', isActive ? 'true' : 'false')
				tab.classList.toggle('is-active', isActive)
			})
			this.panels.forEach((panel) => (panel.hidden = panel.id !== targetId))

			if (window.matchMedia('(max-width: 999px)').matches) {
				button.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })
			}
		}
	}

	if (!window.customElements.get('a-size-chart')) {
		window.customElements.define('a-size-chart', ASizeChart)
	}

  } catch(e) { console.error(e); }
})();
})();
